import React from "react";

const GiRegistryIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21s7-5.4 7-11.2C19 6.03 15.87 3 12 3S5 6.03 5 9.8C5 15.6 12 21 12 21z"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="none"
      />
      <circle cx="12" cy="9.8" r="2.2" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
};

export default GiRegistryIcon;
